export default {
    name: 'depth',
    serverName: '​/api/v1/rb_calculator/depth_of_arable_layer/',
    apiUrl: '/api/v1/rb_calculator/depth_of_arable_layer/'
};
